import type { Point } from '@shared/model/dataset';
import { ONF_CLOSED_TRAILS_URL } from '../site';
import { ExternalLink } from './ExternalLink';
import { PointSelect } from './PointSelect';
import styles from './ItineraryForm.module.css';

interface Props {
    groups: Map<string, Point[]>;
    from: string | null;
    to: string | null;
    onFromChange: (id: string | null) => void;
    onToChange: (id: string | null) => void;
    onSwap: () => void;
    hideClosed: boolean;
    onHideClosedChange: (value: boolean) => void;
}

export function ItineraryForm({
    groups,
    from,
    to,
    onFromChange,
    onToChange,
    onSwap,
    hideClosed,
    onHideClosedChange,
}: Props) {
    return (
        <section id="form-sentier" className={styles.card} aria-labelledby="form-title">
            <h4 id="form-title" className="title-bar">
                Calculez votre itinéraire
            </h4>
            <div className={styles.fields}>
                <div className={styles.field}>
                    <label htmlFor="start">Départ</label>
                    <PointSelect id="start" placeholder="Départ" groups={groups} value={from} onChange={onFromChange} />
                </div>
                <button
                    type="button"
                    className={styles.swap}
                    onClick={onSwap}
                    title="Inverser départ et arrivée"
                    aria-label="Inverser départ et arrivée"
                    disabled={!from && !to}
                >
                    ⇄
                </button>
                <div className={styles.field}>
                    <label htmlFor="end">Arrivée</label>
                    <PointSelect id="end" placeholder="Arrivée" groups={groups} value={to} onChange={onToChange} />
                </div>
            </div>
            <div className={styles.check}>
                <input
                    type="checkbox"
                    id="hide_closed"
                    checked={hideClosed}
                    onChange={(e) => onHideClosedChange(e.target.checked)}
                />
                <label htmlFor="hide_closed">
                    Cacher les sentiers <ExternalLink href={ONF_CLOSED_TRAILS_URL}>fermés par l'ONF</ExternalLink>
                </label>
            </div>
        </section>
    );
}
